import { Outlet } from "react-router-dom";
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";

const OrderViewLayout = () => {
  return (
    <SideNavLayout>
      <div className="flex flex-col h-full">
        {/* Tabs */}
        <div className="flex gap-3 items-center text-gray-800 border-b text-2xl font-bold p-3">
          Order Details
        </div>

        {/* Main content */}
        <div className="grow overflow-auto bg-gray-50 p-4">
          <Outlet />
        </div>
      </div>
    </SideNavLayout>
  );
};

export default OrderViewLayout;
